(function () {
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getHeaderOffset() {
    var value = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    return parseFloat(value) || 0;
  }

  function getAnchorTarget(hash) {
    if (!hash || hash === '#') return null;

    var id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (error) {
      return null;
    }

    return document.getElementById(id);
  }

  function scrollToHash(hash) {
    var target = getAnchorTarget(hash);
    if (!target) return false;

    var targetPosition = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();

    window.scrollTo({
      top: Math.max(targetPosition, 0),
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    });

    return true;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('a[href*="#"]');
    if (!trigger) return;

    var url;
    try {
      url = new URL(trigger.href, window.location.href);
    } catch (error) {
      return;
    }

    if (url.pathname !== window.location.pathname || url.search !== window.location.search) return;
    if (!url.hash || url.hash === '#') return;

    if (!scrollToHash(url.hash)) return;

    event.preventDefault();
    history.pushState(null, '', url.hash);
  });

  window.addEventListener('hashchange', function () {
    scrollToHash(window.location.hash);
  });

  window.addEventListener('DOMContentLoaded', function () {
    if (!window.location.hash) return;

    window.requestAnimationFrame(function () {
      scrollToHash(window.location.hash);
    });
  });
})();
